const JWT = 'JWT';

export const isLoggedIn = () => {
  if (!localStorage.getItem(JWT)) return false;
  else return true;
};

export const addAccessToken = (jwtToken) => {
  localStorage.setItem(JWT, jwtToken);
};
export const getAccessToken = () => {
  return localStorage.getItem(JWT);
};
export const removeToken = () => {
  localStorage.removeItem(JWT);
};
